var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-multi-select',{attrs:{"disabled":_vm.disabled,"value":_vm.value,"label":_vm.label,"fancy":_vm.fancy,"items":_vm.items},on:{"input":function($event){return _vm.onInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }